import api from './client'

export interface Notification {
  id: string
  userId: string
  type: string
  title: string
  body: string
  refType: string | null
  refId: string | null
  isRead: boolean
  createdAt: string
}

export const notificationsApi = {
  list: () => api.get<{ data: Notification[]; meta: unknown }>('/notifications'),
  markRead: (id: string) => api.patch(`/notifications/${id}/read`),
  markAllRead: () => api.post('/notifications/read-all'),
}
